import * as React from 'react';
import { Spinner } from '@teliaee/design-system';
import ErrorUtil from '../../util/ErrorUtil';

interface BankFormProps {
  formPostUrl?: string;
  redirectData: Map<string, string>;
}

const BankForm = (props: BankFormProps): React.JSX.Element | null => {
  const { formPostUrl, redirectData } = props;
  const form = React.createRef<HTMLFormElement>();

  React.useEffect(() => {
    if (form.current?.submit) {
      form.current.submit();
    } else {
      ErrorUtil.pushErrorToTeliaRumAndLogWithLocation('this.form.current?.submit has no value');
    }
  }, []);

  const inputElements: React.JSX.Element[] = [];
  redirectData.forEach((value, key) => {
    inputElements.push(<input type="hidden" name={key} value={value} key={key} />);
  });

  return (
    <span>
      <Spinner />
      <form name="bankLoginForm" method="post" action={formPostUrl} acceptCharset="UTF-8" ref={form}>
        {inputElements.map((element) => {
          return element;
        })}
      </form>
    </span>
  );
};

export default BankForm;
